import React from 'react';
import { observer, inject } from 'mobx-react';
import Container from './Container';

export default inject('model')(
  observer(({ model: user, onClick }) => (
    <Container active={user.is_active} onClick={onClick}>
      {user.is_active ? 'Active' : 'Disabled'}
    </Container>
  )),
);
